import React from 'react'
import { MenuItemInterface } from '../../TenantListing/interfaces/MenuItem'
import { SidebarMenu } from '../constants/Sidebar'
import ErrorIcon from '@mui/icons-material/Error'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import DataObjectRoundedIcon from '@mui/icons-material/DataObjectRounded'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices'
import MemoryIcon from '@mui/icons-material/Memory'
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded'
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import SyncRoundedIcon from '@mui/icons-material/SyncRounded'
import GppMaybeRoundedIcon from '@mui/icons-material/GppMaybeRounded'
import DashboardCustomizeRoundedIcon from '@mui/icons-material/DashboardCustomizeRounded'
import VideoLibraryRoundedIcon from '@mui/icons-material/VideoLibraryRounded'
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead'
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded'
import { TenantIcon } from './TenantIcon'
import { Box } from '@mui/material'

const iconMap: Record<string, React.ElementType> = {
    [SidebarMenu.Tenants]: ManageAccountsIcon,
    [SidebarMenu.EtpSync]: SyncRoundedIcon,
    [SidebarMenu.DataPreview]: DataObjectRoundedIcon,
    [SidebarMenu.APIInsights]: ManageSearchIcon,
    [SidebarMenu.IntegrationInsights]: ElectricalServicesIcon,
    [SidebarMenu.ErrorStatus]: ErrorIcon,
    [SidebarMenu.ServiceStatus]: MemoryIcon,
    [SidebarMenu.InvoiceDashboard]: ReceiptLongRoundedIcon,
    [SidebarMenu.CSDashboard]: DashboardCustomizeIcon,
    [SidebarMenu.SupersetPresets]: DashboardCustomizeRoundedIcon,
    // [SidebarMenu.TenantAnalytics]: BarChartIcon,
    [SidebarMenu.BreachReporting]: GppMaybeRoundedIcon,
    [SidebarMenu.HelpVideos]: VideoLibraryRoundedIcon,
    [SidebarMenu.EmailValidation]: MarkEmailReadIcon,
    [SidebarMenu.ConfigDocs]: MenuBookRoundedIcon,
}

const SidebarIcon = ({ menuName, selected }: MenuItemInterface) => {
    const IconComponent = iconMap[menuName] || TenantIcon

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: selected ? 'primary.main' : 'text.secondary',
                transition: '0.3s',
            }}
        >
            <IconComponent fontSize="medium" />
        </Box>
    )
}

export default SidebarIcon
